import React, { Component } from "react";
import TaskService from "../service/taskService";
import TaskStatusService from "../service/taskStatusService";
import TaskCommentList from "../components/taskCommentList";
import TaskCommentService from "../service/taskCommentService";
import NavigationBar from "../components/navigationBar";
import "../design/main.css";

export default class TaskDetailedSite extends Component {

    constructor(props) {
        super(props);

        this.taskService = new TaskService();
        this.taskStatusService = new TaskStatusService();
        this.taskCommentService = new TaskCommentService();

        this.state =
        {
            task: null,
            newTaskStatus: "",
            taskComments: null,
            CommentText: "",
            SubmittingComment: false
        }

        this.handleSelectChange = this.handleSelectChange.bind(this);

        this.addCommentToTask = this.addCommentToTask.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.formatDateString = this.formatDateString.bind(this)
    }

    componentDidMount() {
        document.title = "Task Detailed";
        this.getTaskDetailed();
        this.getTaskStatuses();
        this.getTaskComments();
    }

    async addCommentToTask(event) {
        event.preventDefault();
        this.setState({
            SubmittingComment: true
        });
        if (this.state.CommentText === "" || this.state.CommentText === null) {
            alert("The comment text cannot be empty");
            this.setState({
                SubmittingComment: false
            });
            return;
        }
        let result = await this.taskCommentService.addCommentToTask(this.props.match.params.taskID, this.state.CommentText);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.getTaskComments();
            this.setState({
                SubmittingComment: false,
                CommentText: ""
            });
        }
    }

    async getTaskComments() {
        let result = await this.taskCommentService.retrieveComments(this.props.match.params.taskID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                taskComments: result
            })
        }
    }

    async updateTaskStatus(event) {
        event.preventDefault();
        let result = await this.taskService.changeTaskStatus(this.props.match.params.taskID, this.state.newTaskStatus);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                task: result
            })
        }
    }

    async getTaskDetailed() {
        let result = await this.taskService.getTaskInDetail(this.props.match.params.taskID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                task: result
            })
        }
    }

    async getTaskStatuses() {
        let result = await this.taskStatusService.getTaskStatuses();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                taskStatuses: result
            })
        }
    }

    formatDateString(dateString){
        return new Date(dateString).toLocaleString();
    }


    handleSelectChange(event) {
        this.setState({
            newTaskStatus: event.target.value
        });
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    render() {
        const task = this.state.task;
        if (!task) return null;
        const taskStatuses = this.state.taskStatuses;
        if (!taskStatuses) return null;
        const taskStatus = taskStatuses.find(element => element.taskStatusID === task.taskStatus);
        if (!taskStatus) return null;
        const comments = this.state.taskComments;
        if (!comments) return null;
        let reporter; let assignee;
        if (this.state.task.reporter != null) {
            reporter = <p>{this.state.task.reporter.userName}</p>
        }
        else {
            reporter = <p>This task have no reporter</p>
        }
        if (this.state.task.assignee != null) {
            assignee = <p>{this.state.task.assignee.userName}</p>
        }
        else {
            assignee = <p>This task have no Assignee</p>
        }
        document.title = task.taskTitle + " - " + taskStatus.statusName;
        console.log(task);
        return (
            <div className="body">


                <NavigationBar {...this.props} />
                <main>
                    {/* <div className="flex-container" style="width: 60%; height: 40%; background-color: #000;"> */}

                    <div className="task-detail-container">
                        {/* <div style="width: 60%;"> */}
                        <div className="task-detail-primary-info">
                            <div className="task-detail-container-vertical">
                                <div>{task.taskTitle}</div>
                                <div>{task.taskDescription}</div>
                                <div><TaskCommentList Comments={this.state.taskComments} /></div>
                                <div>
                                    <form action="#" onSubmit={(event) => { this.addCommentToTask(event) }}>
                                        <input type="text" placeholder="Comment Text" name="CommentText" value={this.state.CommentText} onChange={this.handleChange} required></input>
                                        <button type="submit" disabled={this.state.SubmittingComment}>Create Task comment</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        {/* <div style="width: 40%"> */}
                        <div className="task-detail-secondary-info">
                            <div className="task-detail-container-vertical">
                                {/* <div>{task.tasktype}</div> */}
                                <div>{taskStatus.statusName}
                                    <form action="#" onSubmit={(event) => { this.updateTaskStatus(event) }}>

                        <select name="taskStatus" id="newTaskStatus" onChange={this.handleSelectChange} value={this.state.newTaskStatus}>
                            <option disabled={true} value={""}> -- select an option -- </option>
                            {taskStatuses.map(taskstatusloop => (
                                <option value={taskstatusloop.taskStatusID} key={taskstatusloop.taskStatusID}>{taskstatusloop.statusName}</option>
                            ))}
                        </select>
                        <button type="submit">Update Task Status</button>
                    </form>
                                </div>
                                <div>{reporter}</div>
                                <div>{assignee}</div>
                                <div>{this.formatDateString(task.createdOn)}</div>
                                <div>{this.formatDateString(task.lastUpdated)}</div>
                        </div>
                        </div>
                    </div>
                </main>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/TaskDetailedSite.js